import Layout from "../../components/layout/Layout"
import { Helmet } from 'react-helmet';

const PrivacyPolicyEN = () => {
    return (
        <div>
            <Helmet>
                <meta name="description" content="Privacy Policy" />
            </Helmet>
            <div className="container" style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 30 }}>
                <h2>Privacy Policy</h2>
                <p>We, Limited Liability Company “SUNPOINT IT SOLUTIONS”, EDRPOU code 42783354, in accordance with the Law of Ukraine dated June 1, 2010, No. 2297-VI “On the Protection of Personal Data” (hereinafter referred to as the “Law”), are committed to ensuring the confidentiality of your personal data. Personal data refers to information that can identify you, such as your name, surname, email address, phone number, and any other details you voluntarily provide to us.</p>

                <p>The company takes great care in protecting the confidential (personal) information of all individuals who visit the platform or use the services provided. Accordingly, the company strives to protect the confidentiality of personal data, creating and ensuring the most comfortable conditions for the use of the platform’s services for every user.</p>

                <p>This Privacy Policy explains how we collect, use, and protect your personal information when using our SkTech platform (hereinafter referred to as the “Platform”). By using our Platform, you agree to the terms of this Privacy Policy.</p>

                <h3>1. Collection and Use of Personal Data</h3>
                <ol>
                    <li>
                        <p>The Platform collects the following data:</p>
                        <ul>
                            <li>Name, surname, email address, phone number;</li>
                            <li>Information provided voluntarily by the user (during registration, inquiries).</li>
                        </ul>
                    </li>
                    <li>
                        <p>Purpose of data processing:</p>
                        <ul>
                            <li>Providing access to the service;</li>
                            <li>Technical support;</li>
                            <li>Informing about news and updates;</li>
                            <li>Analytics to improve service quality.</li>
                        </ul>
                    </li>
                </ol>

                <h3>2. Data Protection and Storage</h3>
                <ol>
                    <li>The Platform ensures an adequate level of protection for users’ personal data from unauthorized access, loss, or modification.</li>
                    <li>Storage period: until the user’s profile is deleted or the Platform ceases to operate.</li>
                </ol>

                <h3>3. Disclosure of Personal Data</h3>
                <ol>
                    <li>
                        The Platform does not transfer personal data to third parties, except in cases where the data may be provided to:
                        <ul>
                            <li>Payment systems for processing transactions;</li>
                            <li>Partners for servicing the Platform;</li>
                            <li>Authorized bodies in accordance with the legislation of Ukraine.</li>
                        </ul>
                    </li>
                </ol>

                <h3>4. Use of Cookies</h3>
                <ol>
                    <li>Cookies are used to store user settings, analyze traffic, and improve the functionality of the Platform. Users can opt out of cookies in their browser settings, but this may limit functionality.</li>
                </ol>

                <h3>5. User Rights</h3>
                <ol>
                    <li>
                        Users have the right to:
                        <ul>
                            <li>Access and modify their data;</li>
                            <li>Restrict processing or request the deletion of data;</li>
                            <li>Requests can be submitted through the contact information provided below.</li>
                        </ul>
                    </li>
                </ol>

                <h3>6. Changes to the Policy</h3>
                <p>The Platform reserves the right to modify this Privacy Policy. Updates will be published with the effective date. Continued use of the Platform signifies acceptance of the changes.</p>

                <h3>7. Contact Information</h3>
                <p>LLC “SUNPOINT IT SOLUTIONS”<br />
                    EDRPOU Code: 42783354<br />
                    Address: Serpova St. 11, Kyiv, Ukraine<br />
                    Email: sktech@sunpoint.com.ua</p>

                <p>Last updated: November 27, 2024</p>
            </div>

        </div>
    )
}
export default PrivacyPolicyEN;